import { RateTableCarrier } from "@redotech/redo-fulfillment-outbound-labels-common/rate-table-carrier";
import { RateProvider } from "@redotech/redo-model/outbound-labels/outbound-labels";
import {
  RateTableType,
  RateTableValueMode,
  serviceLevelsSchema,
} from "@redotech/redo-model/rate-table/rate-table";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const baseDeleteRateTable = z.object({
  teamId: z.string().optional(),
  carrier: createEnum(RateTableCarrier).optional(),
  valueMode: createEnum(RateTableValueMode),
  rateTableType: createEnum(RateTableType),
  provider: createEnum(RateProvider).optional(),
  serviceLevel: serviceLevelsSchema.optional(),
});

export const deleteRateTable = {
  name: "deleteRateTable" as const,
  input: baseDeleteRateTable,
  output: z.object({ success: z.boolean() }),
};
